<div class="px-lg-2 certificates-list-header">
  <div class="certificates-list-search">
    <mat-form-field>
      <input
        matInput
        autocomplete="off"
        (keyup)="$event.stopPropagation(); $event.preventDefault(); applyFilter($event.target.value)"
        placeholder="Search"
        #searchInput/>
      <mat-icon
        class="pointer"
        *ngIf="searchInput.value"
        (click)="$event.stopPropagation(); $event.preventDefault(); applyFilter(''); searchInput.value = ''"
        matSuffix>
        close
      </mat-icon>
    </mat-form-field>
  </div>
  <div class="certificates-list-description">
    <span> {{ 'WEB-SIGN.SIGNTRUST-LIB.CERTIFICATES-LIST.AVAILABLE-CERTIFICATES' | translate }} </span>
  </div>
</div>
<div class="certificates-list-content">
  <div class="certificates-list-content">
    <ng-container *ngIf="loadingInfo; then loadingPoints; else certificates"></ng-container>
    <ng-template #loadingPoints>
      <div class="certificates-list-loading">
        <span class="loader"></span>
      </div>
    </ng-template>
    <ng-template #certificates>
      <ng-container *ngIf="dataSource?.filteredData.length > 0">
        <div class="card-wrapper" *ngFor="let certificate of dataSource?.filteredData">
          <div class="card-content w-100" (click)="focusCertificate(certificate)">
            <div class="card-select-button">
              <mat-radio-button color="primary" [checked]="focusedCertificate?.certificateHandler === certificate.certificateHandler"> </mat-radio-button>
            </div>
            <div class="card-logo d-none d-lg-block">
              <span class="d-inline-block list-row-icon">
                <i class="rt-icon rt-certificate fs35"></i>
              </span>
            </div>
            <div class="card-info">
              <div class="card-row">
                <span class="card-col text highlight">
                  <span *ngIf="certificate?.alias">
                    {{ certificate.alias }}
                  </span>
                  <span class="text-danger d-inline-block" *ngIf="!certificate?.alias">
                    {{ 'WEB-SIGN.SIGNTRUST-LIB.CERTIFICATES-LIST.CARD.DETAILS.NO-ALIAS' | translate }}
                  </span>
                </span>
              </div>
              <div class="card-row">
                <span class="card-col text">
                  {{ 'WEB-SIGN.SIGNTRUST-LIB.CERTIFICATES-LIST.CARD.ISSUER' | translate }}&nbsp;
                  <span *ngIf="certificate?.issuer"> {{ certificate.issuer }},&nbsp; </span>
                  <span class="text-danger d-inline-block" *ngIf="!certificate?.issuer">
                    {{ 'WEB-SIGN.SIGNTRUST-LIB.CERTIFICATES-LIST.CARD.DETAILS.NO-ISSUER' | translate }}&nbsp;
                  </span>
                </span>
                <span class="card-col text">
                  {{ 'WEB-SIGN.SIGNTRUST-LIB.CERTIFICATES-LIST.CARD.EXPIRES' | translate }}&nbsp;
                  <span *ngIf="certificate?.expiration">
                    {{ certificate.expiration | dateMultiLang: 'currentLang':'small' }}
                  </span>
                  <span class="text-danger d-inline-block" *ngIf="!certificate?.expiration">
                    {{ 'WEB-SIGN.SIGNTRUST-LIB.CERTIFICATES-LIST.CARD.DETAILS.NO-EXPIRATION' | translate }}
                  </span>
                </span>
              </div>
            </div>
            <div class="h-100 card-detail-button" (click)="$event.stopPropagation()" (onclick)="$event.stopPropagation()">
              <button
                class="h-100 dialog-button"
                (click)="$event.preventDefault(); $event.stopPropagation(); openDetailsDialog(certificate)">
                {{ 'WEB-SIGN.SIGNTRUST-LIB.CERTIFICATES-LIST.CARD.VIEW-DETAILS' | translate }}
              </button>
            </div>
          </div>
        </div>
      </ng-container>
      <div *ngIf="dataSource?.filteredData.length === 0" class="w-100 p-1">
        <div *ngIf="dataSource?.filter" class="notify notify-info wb-ball">
          <span class="notify-message text-center">
            {{ 'WEB-SIGN.SIGNTRUST-LIB.NO-RESULTS-FOR' | translate }} <b class="fw-bold">"{{ dataSource.filter }}"</b>.
          </span>
        </div>
        <div *ngIf="!dataSource?.filter" class="notify notify-info wb-ball">
          <span class="notify-message text-center">
            {{ 'WEB-SIGN.SIGNTRUST-LIB.NO-RESULTS' | translate }}
          </span>
        </div>
      </div>

    </ng-template>
  </div>
</div>
